import { Fab, IconButton, Tooltip } from '@mui/material';
import Link from 'next/link';
import { useTheme } from '@mui/material/styles';
import { IconBrandLinkedin, IconBrandFacebook, IconBrandYoutube, IconBrandInstagram } from '@tabler/icons-react';

const SocialMedia = () => {
  const theme = useTheme();

  return (
    <Fab
      component="div"
      size="medium"
      variant="circular"
      sx={{
        borderRadius: 2,
        top: '25%',
        position: 'fixed',
        right: 10,
        zIndex: 1200,
        backgroundColor: '#FEFEFF',
        flexDirection: 'column',
        height: 'auto',
        display: { xs: 'none', sm: 'flex' },
        justifyContent: 'center',
        alignItems: 'center'
      }}
      disableTouchRipple
    >
      <Tooltip title="LinkedIn">
        <Link href="https://www.linkedin.com/company/andevos/" target="_blank">
          <IconButton
            color="inherit"
            size="medium"
            disableRipple
            aria-label="LinkedIn"
            sx={{
              margin: '4px 0',
              '&:hover': {
                backgroundColor: theme.palette.grey[300],
                color: '#0077B5'
              }
            }}
          >
            <IconBrandLinkedin />
          </IconButton>
        </Link>
      </Tooltip>
      <Tooltip title="Instagram">
        <Link href="https://www.instagram.com/andevosbilgiteknolojileri/" target="_blank">
          <IconButton
            color="inherit"
            size="medium"
            disableRipple
            aria-label="Instagram"
            sx={{
              margin: '4px 0',
              '&:hover': {
                color: '#E4405F',
                backgroundColor: theme.palette.grey[300]
              }
            }}
          >
            <IconBrandInstagram />
          </IconButton>
        </Link>
      </Tooltip>
      <Tooltip title="Facebook">
        <Link href="https://www.facebook.com/andevosbt" target="_blank">
          <IconButton
            color="inherit"
            size="medium"
            disableRipple
            aria-label="Facebook"
            sx={{
              margin: '4px 0',
              '&:hover': {
                color: '#1877F2',
                backgroundColor: theme.palette.grey[300]
              }
            }}
          >
            <IconBrandFacebook />
          </IconButton>
        </Link>
      </Tooltip>
      <Tooltip title="Youtube">
        <Link href="https://www.youtube.com/@AndevosBilgiTeknolojileri" target="_blank">
          <IconButton
            color="inherit"
            size="medium"
            disableRipple
            aria-label="Youtube"
            sx={{
              margin: '4px 0',
              '&:hover': {
                color: '#FF0000',
                backgroundColor: theme.palette.grey[300]
              }
            }}
          >
            <IconBrandYoutube />
          </IconButton>
        </Link>
      </Tooltip>
    </Fab>
  );
};

export default SocialMedia;
